<script>
export default {
  name: 'IconIaImagem',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.3584 3.75678V18.3581H3.75703V3.75678H18.3584ZM9.90267 7.40712H8.48067L5.78091 14.7078H7.06381L7.57351 13.2806H10.8053L11.3041 14.7078H12.6643L9.90267 7.40712ZM14.9415 7.40712H13.6638V14.7078H14.9415V7.40712ZM9.1809 8.63199L10.4536 12.2742H7.92839L9.1809 8.63199ZM19.5752 14.7078H22.0087V17.1413H19.5752V14.7078ZM4.9738 19.5749H7.40736V22.0085H4.9738V19.5749ZM9.84092 19.5749H12.2745V22.0085H9.84092V19.5749ZM4.9738 0.106445H7.40736V2.54H4.9738V0.106445ZM14.708 19.5749H17.1416V22.0085H14.708V19.5749ZM9.84092 0.106445H12.2745V2.54H9.84092V0.106445ZM14.708 0.106445H17.1416V2.54H14.708V0.106445ZM19.5752 9.84068H22.0087V12.2742H19.5752V9.84068ZM0.106689 14.7078H2.54025V17.1413H0.106689V14.7078ZM19.5752 4.97356H22.0087V7.40712H19.5752V4.97356ZM0.106689 9.84068H2.54025V12.2742H0.106689V9.84068ZM0.106689 4.97356H2.54025V7.40712H0.106689V4.97356Z"
      :fill="color"
      fill-opacity="0.8"
    />
  </svg>
</template>
